export default __webpack_public_path__ + "static/media/tap.08f75ed5.wav";